import { Grid, Typography } from '@mui/material';
import _ from 'lodash';
import React, { memo, useState } from 'react'
import { useStyle } from '../style';
import QrInfo from './qrInfo';
import PurchasedData from './purchasedData';
import { Helmet } from 'react-helmet-async';

const PurchaseQR = () => {
    const classes = useStyle()
    const [data, setData] = useState([])
    const [flag, setFlag] = useState(false)
return(
    <Grid className={classes.root}>
        <Helmet><title>Purchase QR Generate</title></Helmet>
        <Grid className={classes.titleInfo}>
            <Typography  variant="h5" fontWeight={600}>Purchase QR</Typography>
        </Grid>
        <Grid className={classes.contentGrid}>
        <Grid className="w-full">
          <Grid className="border-b"><QrInfo setData={setData} flag={flag}/></Grid>
          <Grid className="p-2 " sx={{flex:1}}><PurchasedData data={data}  flag={flag} setFlag={setFlag}/></Grid>
        </Grid>
        </Grid>
    </Grid>
)
}

export default memo(PurchaseQR)